import { useState } from "react";
import Loading from "../components/loading";
import {useNavigate} from "react-router-dom";
import { collection, getDocs, getDoc, doc, onSnapshot, setDoc, getFirestore} from "firebase/firestore";
import swal from "sweetalert";

export default function Login(){

  let navigate = useNavigate();
  const db=getFirestore();
  const [hide, setHide] = useState(true);
  const [loading, setLoading] = useState(false);
  const [password,setPassword]=useState("");
  const [email,setEmail]=useState("");



    const handleEmailChange= (e)=>{
        setEmail(e.target.value)
        console.log(e.target.value)
    }

    const handlePasswordChange= (e)=>{
        setPassword(e.target.value)
        console.log(e.target.value)
    }


        return(
        loading===true?
            <Loading/>:
            <div style={{fontFamily:'Arial'}} className='h-screen w-screen flex bg-gradient-to-t from-blue-900 to-blue-400 items-center justify-center'>
                <div className="absolute z-0 flex flex-col justify-center items-center">

                    <div className="w-72 md:w-1/5 backdrop-blur-sm rounded-md">
                        <img alt="logo" src="/logo.png"/>
                    </div>

                    <div className="mt-12 w-3/4 md:w-1/4 bg-white flex flex-col p-10 rounded-md shadow-xl">

                        <input
                            onChange={(e)=>handleEmailChange(e)}
                            placeholder="Email"
                            className="text-black font-normal text-md bg-black/10 p-3 rounded-sm"/>


                        <div className="mt-10 flex flex-row">
                            <input
                                onChange={(e)=>handlePasswordChange(e)}
                                type={hide===true?"password":"text"}
                                placeholder="Password"
                                className="md:w-5/6 w-4/6 text-black font-normal text-md bg-black/10 p-3 rounded-sm"/>

                            <button
                                onClick={()=>{
                                    setHide(!hide);
                                }}
                                className="md:w-1/6 w-2/6 bg-black/10 flex justify-center items-center">
                                👁️
                            </button>

                        </div>

                        <button
                            onClick={async  ()=>{

                                setLoading(true);
                                
                                var snap= await getDoc(doc(db,"admin",email));
                                if(snap.exists()==true){
                                   if(snap.data()["password"]==password){
                                    setLoading(false);
                                    localStorage.setItem('authorized', "true");
                                    localStorage.setItem('user', email);
                                    navigate("/home");
                                    console.log("logged in");
                                   }
                                   else{
                                       swal("Wrong Password");
                                        setLoading(false);
                                   }
                                }
                                else{
                                    swal("Account Doesnt Exist");
                                    setLoading(false);
                                }

                            }}
                            className="shadow-xl hover:scale-105 mt-12 w-3/4 self-center md:w-4/5 text-white font-bold text-xl bg-yellow-400 p-2 rounded-sm">
                            Log In
                        </button>

                    </div>


                </div>
            </div>
            )
}